import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getBuildings(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_BUILDINGS_REQUEST,
			payload: { loading: true }
		});

		const response = await API.buildings.getBuildings({ ...options });

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_BUILDINGS_ERROR,
				payload: {
					meta: response.meta,
					locations: null,
					buildings: null
				}
			});
			return;
		}

		const { buildings, total } = response.data;

		dispatch({
			type: ActionTypes.GET_BUILDINGS_SUCCESS,
			payload: {
				loading: false,
				locations: null,
				total,
				buildings
			}
		});
	};
}

export function getLocations(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_LOCATIONS_REQUEST,
			payload: { loading: true }
		});

		const response = await API.locations.getLocations({ ...options });

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATIONS_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { locations, total } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATIONS_SUCCESS,
			payload: {
				loading: false,
				total,
				locations
			}
		});
	};
}

export function getLocationsByType(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_LOCATIONS_BY_TYPE_REQUEST,
			payload: { loadingLocType: true }
		});

		const response = await API.locations.getLocationsByType({ ...options });

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATIONS_BY_TYPE_ERROR,
				payload: {
					meta: response.meta,
					loadingLocType: false
				}
			});
			return;
		}

		const { filtered_locations, total } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATIONS_BY_TYPE_SUCCESS,
			payload: {
				loadingLocType: false,
				buildings: null,
				locations: null,
				total,
				filteredLocations: filtered_locations
			}
		});
	};
}

export function getPointOfInterestTypes(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_LOCATIONS_POINT_OF_INTEREST_TYPES_REQUEST
		});

		const response = await API.point_of_interest_types.getPointOfInterestTypes({ ...options });

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATIONS_POINT_OF_INTEREST_TYPES_ERROR,
				payload: {
					meta: response.meta
				}
			});
			return;
		}

		const { point_of_interest_types, total: point_of_interest_types_total } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATIONS_POINT_OF_INTEREST_TYPES_SUCCESS,
			payload: {
				point_of_interest_types_total,
				point_of_interest_types
			}
		});
	};
}

export function getPointOfInterests(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_POINT_OF_INTERESTS_REQUEST
		});

		const response = await API.point_of_interests.getPointOfInterests(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_POINT_OF_INTERESTS_ERROR,
				payload: {
					meta: response.meta
				}
			});
			return;
		}

		const { point_of_interests } = response.data;

		dispatch({
			type: ActionTypes.GET_POINT_OF_INTERESTS_SUCCESS,
			payload: {
				point_of_interests
			}
		});
	};
}

// `panorama_nodes_building_floor_id` records the floor the nodes in the store belong to, and
// `loading_panorama_nodes` when a newer floor's request is still out. Together they let the map
// tell "this floor has no 360 imagery" apart from "the answer for this floor is not back yet" —
// which it has to, to explain an empty 360 view instead of leaving the user on an unchanged map.
export function getPanoramaNodes(options) {
	return async (dispatch) => {
		const { building_floor_id } = options || {};

		dispatch({
			type: ActionTypes.GET_PANORAMA_NODES_REQUEST,
			payload: {
				loading_panorama_nodes: true
			}
		});

		const response = await API.panorama_nodes.getPanoramaNodes(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_PANORAMA_NODES_ERROR,
				payload: {
					meta: response.meta,
					// A floor whose nodes could not be fetched has nothing to draw either, so it is
					// reported as empty rather than left holding the previous floor's graph.
					panorama_nodes: [],
					panorama_nodes_building_floor_id: building_floor_id,
					loading_panorama_nodes: false
				}
			});
			return;
		}

		const { panorama_nodes } = response.data;

		dispatch({
			type: ActionTypes.GET_PANORAMA_NODES_SUCCESS,
			payload: {
				panorama_nodes,
				panorama_nodes_building_floor_id: building_floor_id,
				loading_panorama_nodes: false
			}
		});
	};
}

export function getPanoramaEdges(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_PANORAMA_EDGES_REQUEST
		});

		const response = await API.panorama_edges.getPanoramaEdges(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_PANORAMA_EDGES_ERROR,
				payload: {
					meta: response.meta
				}
			});
			return;
		}

		const { panorama_edges } = response.data;

		dispatch({
			type: ActionTypes.GET_PANORAMA_EDGES_SUCCESS,
			payload: {
				panorama_edges
			}
		});
	};
}

export function getAllBaseMap() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_ALL_BASE_MAP_REQUEST
		});

		const response = await API.asset.getAllBaseMap();

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_ALL_BASE_MAP_ERROR,
				payload: {
					meta: response.meta
				}
			});
			return;
		}

		const { all_base_map } = response.data;

		dispatch({
			type: ActionTypes.GET_ALL_BASE_MAP_SUCCESS,
			payload: {
				all_base_map
			}
		});
	};
}

export function getPanoramaNodeById(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_PANORAMA_NODE_BY_ID_REQUEST,
			payload: { loading: true }
		});

		const response = await API.panorama_nodes.getPanoramaNodeById(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_PANORAMA_NODE_BY_ID_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { panorama_node } = response.data;

		dispatch({
			type: ActionTypes.GET_PANORAMA_NODE_BY_ID_SUCCESS,
			payload: {
				loading: false,
				panorama_node
			}
		});
	};
}

export function resetMeta() {
	return async dispatch =>
		dispatch({ type: ActionTypes.RESET_LOCATIONS_META });
};

export function resetPage() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_LOCATIONS_PAGE });
	};
}